import { useEffect } from "react";
import "./css/Home.css";

import SectionHero from "./Main/SectionHero";
import SectionFeatures from "./Main/SectionFeatures";
import SectionPlatform from "./Main/SectionPlatform";
import SectionMessage from "./Main/SectionMessage";

import { ReactComponent as MessageSvg } from "../assets/undraw_envelope_re_f5j4.svg";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main className="landing-home">
      <SectionHero />
      <SectionFeatures />
      <SectionPlatform />
      <SectionMessage illustration={<MessageSvg />} />
    </main>
  );
}

export default Home;
